module.exports = __webpack_public_path__ + "img/story1.91b5b81a.png";